"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hoursInMinutes = exports.hoursInSeconds = exports.hoursInMs = exports.minutesAsHours = exports.minutesInSeconds = exports.minutesInMs = exports.secondsAsHours = exports.secondsAsMinutes = exports.secondsInMs = exports.msAsHour = exports.msAsMinutes = exports.msAsSeconds = exports.HOUR_IN_MS = exports.HOUR_IN_SECONDS = exports.HOUR_IN_MINUTES = exports.MINUTE_IN_MS = exports.MINUTE_IN_SECONDS = exports.SECOND_IN_MS = void 0;
const multiplyBy = (factor) => {
    return (value) => {
        return value * factor;
    };
};
const divideBy = (factor) => {
    return (value) => {
        return value / factor;
    };
};
const chain = (...actions) => {
    return (value) => {
        return actions.reduce((acc, fn) => {
            return fn(acc);
        }, value);
    };
};
exports.SECOND_IN_MS = 1000;
exports.MINUTE_IN_SECONDS = 60;
exports.MINUTE_IN_MS = exports.MINUTE_IN_SECONDS * exports.SECOND_IN_MS;
exports.HOUR_IN_MINUTES = 60;
exports.HOUR_IN_SECONDS = exports.HOUR_IN_MINUTES * exports.MINUTE_IN_SECONDS;
exports.HOUR_IN_MS = exports.HOUR_IN_SECONDS * exports.SECOND_IN_MS;
exports.msAsSeconds = divideBy(exports.SECOND_IN_MS);
exports.msAsMinutes = chain(divideBy(exports.SECOND_IN_MS), divideBy(exports.MINUTE_IN_SECONDS));
exports.msAsHour = chain(divideBy(exports.SECOND_IN_MS), divideBy(exports.MINUTE_IN_SECONDS), divideBy(exports.HOUR_IN_MINUTES));
exports.secondsInMs = multiplyBy(exports.SECOND_IN_MS);
exports.secondsAsMinutes = divideBy(exports.MINUTE_IN_SECONDS);
exports.secondsAsHours = chain(divideBy(exports.MINUTE_IN_SECONDS), divideBy(exports.HOUR_IN_MINUTES));
exports.minutesInMs = chain(multiplyBy(exports.MINUTE_IN_SECONDS), multiplyBy(exports.SECOND_IN_MS));
exports.minutesInSeconds = multiplyBy(exports.MINUTE_IN_SECONDS);
exports.minutesAsHours = divideBy(exports.HOUR_IN_MINUTES);
exports.hoursInMs = chain(multiplyBy(exports.HOUR_IN_MINUTES), multiplyBy(exports.MINUTE_IN_SECONDS), multiplyBy(exports.SECOND_IN_MS));
exports.hoursInSeconds = chain(multiplyBy(exports.HOUR_IN_MINUTES), multiplyBy(exports.MINUTE_IN_SECONDS));
exports.hoursInMinutes = multiplyBy(exports.HOUR_IN_MINUTES);
//# sourceMappingURL=time.js.map